import React, { ReactElement } from 'react';
import { FormDialog } from 'dialog';
import { CheckIcon } from 'components/icons';
import { EditGatewayFormData } from 'containers/jobsiteConfiguration/types';
import { EditGatewayModalProps } from './types';
import { getDefaultValues, getFormInputs } from './EditGatewayModal.forms';

export function EditGatewayModal(props: EditGatewayModalProps): ReactElement {
  const { isOpen, onCancel, onConfirm, gateway, gateways } = props;

  const onSubmit = React.useCallback(
    (data: EditGatewayFormData): void => {
      onConfirm?.({ ...gateway, ...data });
    },
    [onConfirm, gateway],
  );

  const formInputs = React.useMemo(
    () => getFormInputs({ gateways, gateway }),
    [gateways, gateway],
  );
  const defaultValues = React.useMemo(
    () => getDefaultValues(gateway),
    [gateway],
  );

  return (
    <FormDialog
      id="editGateway"
      open={isOpen}
      setOpen={onCancel}
      title="Edit Gateway"
      inputs={formInputs}
      onSubmit={onSubmit}
      defaultValues={defaultValues}
      inputsContainerClassName="odin-grid odin-grid-cols-6 odin-gap-6"
      actionText="Save Changes"
      actionIcon={CheckIcon}
    />
  );
}
